import React from "react";
import Switch from "react-switch";

const LabeledSwitch = ({
  id,
  leftLabel = "No",
  rightLabel = "Yes",
  checked,
  onChange,
  isLoading = false,
  onColor = "#86d3ff",
  onHandleColor = "#2693e6",
  offColor = "#ffffff",
  offHandleColor = "#fbb033",
  handleDiameter = 18,
  height = 20,
  width = 44,
  label = "", // Optional main label above or inline if needed
}) => {
  return (
    <div className="flex flex-col lg:flex-row items-center  w-full gap-16">
      {label && (
        <span className="font-be-jost-pro font-medium text-white text-sm">
          {label}:
        </span>
      )}
      <div className="flex items-center gap-2 px-3 py-2  border-[#E0E0E0]">
        <span className="text-white text-sm ">{leftLabel}</span>
        <div className="relative">
          <Switch
            id={id}
            checked={checked}
            onChange={onChange}
            onColor={onColor}
            onHandleColor={onHandleColor}
            offColor={offColor}
            offHandleColor={offHandleColor}
            handleDiameter={handleDiameter}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={height}
            width={width}
            className="react-switch"
          />
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-black/20 rounded">
              <svg
                className="animate-spin h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8z"
                ></path>
              </svg>
            </div>
          )}
        </div>
        <span className="text-white text-sm">{rightLabel}</span>
      </div>
    </div>
  );
};

export default LabeledSwitch;
